'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lineConstants = require('./lineConstants');

var _elementRegistry = require('../elements/elementRegistry');

var _elementConstructor = require('../elements/elementConstructor');

var _elementConstructor2 = _interopRequireDefault(_elementConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var objectConstructorFn = function objectConstructorFn(params) {
    var _extends2;

    var content = params.content;

    return _extends({}, (0, _elementConstructor2.default)(params), {
        elementType: _lineConstants.LINE_TYPE,
        content: _extends((_extends2 = {}, _defineProperty(_extends2, _lineConstants.LINE_EDGE.start, {
            x: 0,
            y: _lineConstants.DEFAULT_LINE_HEIGHT
        }), _defineProperty(_extends2, _lineConstants.LINE_EDGE.end, {
            x: _lineConstants.DEFAULT_LINE_WIDTH,
            y: 0
        }), _defineProperty(_extends2, 'startStyle', _lineConstants.LINE_MARKER_STYLE.NONE), _defineProperty(_extends2, 'endStyle', _lineConstants.LINE_MARKER_STYLE.ARROW), _defineProperty(_extends2, 'lineStyle', _lineConstants.LINE_STYLE.SOLID), _defineProperty(_extends2, 'textContent', null), _extends2), content)
    });
};

exports.default = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _elementRegistry.registerElementType)(_extends({
        elementType: _lineConstants.LINE_TYPE,
        objectConstructorFn: objectConstructorFn,
        displayName: _lineConstants.LINE_DISPLAY_NAME
    }, params));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/lines/index.js
// module id = 2273
// module chunks = 0